module.exports = __webpack_public_path__ + "static/img/xcx.3475955.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/assets/img/xcx.jpg
// module id = 8RUx
// module chunks = 1